export function convertScreamingSnakeCaseToTitleCase(screamingSnakeCase: string): string {
  return screamingSnakeCase
    .split('_')
    .map((word) => word[0] + word.slice(1).toLowerCase())
    .join(' ');
}

export function getUserInitialsFromDisplayName(displayName: string): string {
  if (!displayName) {
    return;
  }
  const separatedWords = displayName.split(' ');
  if (separatedWords.length > 1) {
    return `${separatedWords[0][0] + separatedWords[1][0]}`.toUpperCase();
  } else if (displayName.length === 1) {
    return displayName[0];
  } else {
    return `${separatedWords[0][0] + separatedWords[0][1]}`.toUpperCase();
  }
}
